<template>
  <b-row>
    <b-col sm="12">
      <b-card>
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Listas de Proveedores</h4>
            <div class="small text-muted">Administrador de las listas de precios por proveedores</div>
          </b-col>                            
        </b-row>
      </b-card>

      <b-card v-if="!statusEditPrice">
        <b-row>
          <b-col sm="10">
            <b-row>                                                       
              <b-col sm="3">
                <v-select :options="arr.filters.suppliers" v-model="filters.suppliers" placeholder="Proveedores" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>  
              <b-col sm="2">
                <b-button variant="outline-dark" @click="loadSuppliers()" size="sm">
                  <b-icon icon="filter" class="mr-1" style="font-size:15px;"></b-icon>              
                  Filtrar
                </b-button>
              </b-col>              
            </b-row>
          </b-col>

          <b-col sm="2" v-if="table.items && table.items.length">
            <b-row>
              <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
                <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                  <i class="fa fa-filter"></i> Mostrar Filtros
                </b-button>
              </b-col>
              <b-col sm="12" class="d-none d-md-block" v-else>
                <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                  <i class="fa fa-window-close"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-col>

        </b-row>
      </b-card>

      <b-row>
        <b-col lg="3" :style="{'display': statusEditPrice ? 'none': 'block'}">
          <b-card id="cost-tree-suppliers">
            <vue-tree-list
              @click="selectedItem"              
              :model="suppliersTree"
              v-bind:default-expanded="false"              
            >                      
              <template v-slot:leafNameDisplay="slotProps">                
                <span>
                  &nbsp;&nbsp;{{ slotProps.model.name }}
                </span>
              </template>              

            </vue-tree-list>                     

            <div v-if="suppliers">
              <b-alert show v-if="!suppliers.length" variant="warning">
                No se encontraron proveedores con listas de precios cargadas
              </b-alert>
            </div>
          </b-card>          
        </b-col>        
        <b-col :lg="statusEditPrice ? 12 : 9">
          <b-card>
            <b-row v-if="table.mostrarFiltros">
              <b-col sm="3">
                <b-form-group>
                  <b-input-group>
                    <b-form-input type="text" size="sm" placeholder="Ingrese código o nombre" v-model="filterQuery.text"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>   
              <b-col sm="2">
                <v-select :options="arr.select.linkedProduct" v-model="filterQuery.linkedProduct" placeholder="Producto Vinculado" :multiple="false" :select-on-tab="true"></v-select>
              </b-col>
              <b-col sm="2">
                <v-select :options="arr.select.notImported" v-model="filterQuery.notImported" placeholder="No Importados" :multiple="false" :select-on-tab="true"></v-select>
              </b-col>
              <b-col sm="2">
                <v-select :options="arr.select.lastUpdate" v-model="filterQuery.lastUpdate" placeholder="Ultima Actualización" :multiple="false" :select-on-tab="true"></v-select>
              </b-col>                                                        
              <b-col sm="2">
                <b-button variant="outline-dark" @click="selectedItem(filterQuery, true)" size="sm">
                  <b-icon icon="filter" class="mr-1" style="font-size:15px;"></b-icon>              
                  Filtrar
                </b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="8">
                <b>{{this.itemSelected}}</b>
                <span class="crud-price-list-suppliers-download">
                  <b-link v-if="itemSelected" title="Descargar lista de precios en formato CSV para el proveedor seleccionado">
                    <b-icon icon="download" animation="throb" variant="success" @click="prepareExport()"></b-icon>
                  </b-link>                                                                               
                </span>
                <span v-if="statusEditPrice" class="ml-3">
                  <b-link href="javascript:void(0);" @click="endChangePrice()" title="Click para finalizar edición">
                    <b-badge variant="warning">
                      FINALIZAR MODO EDICIÓN DE PRECIOS MÚLTIPLE
                    </b-badge>
                  </b-link>
                </span>
              </b-col>
              <b-col sm="4" v-if="!statusEditPrice">
                <b-dropdown right 
                            text="Opciones" 
                            variant="primary" 
                            size="sm"
                            class="btn-pill float-right ml-2" 
                            v-b-tooltip.hover 
                            title="Opciones de Edición" 
                            v-if="access.elements.changeProductsSale">                  
                  <b-dropdown-item @click="addProduct()">
                    <b-icon icon="plus"></b-icon> Agregar Producto
                  </b-dropdown-item>

                  <b-dropdown-divider v-if="itemSelected"></b-dropdown-divider>
                  <b-dropdown-item @click="initChangePrice()" v-if="itemSelected">
                    <b-icon icon="pencil-square"></b-icon> Edición Múltiple
                  </b-dropdown-item>

                  <b-dropdown-divider v-if="itemSelected"></b-dropdown-divider>
                  <b-dropdown-item @click="showEditPriceLote()" v-if="itemSelected" title="Modifica el precio de lista de todos los productos filtrados">
                    <b-icon icon="percent"></b-icon> Edición general de precios
                  </b-dropdown-item>
                  <b-dropdown-item @click="showEditDiscountLote()" v-if="itemSelected" title="Agrega el mismo descuento a todos los productos filtrados">
                    <b-icon icon="segmented-nav"></b-icon> Edición general de descuentos
                  </b-dropdown-item>                                    

                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="openImportCSV()">                    
                    <b-icon icon="file-earmark-excel-fill"></b-icon> Importaciones
                  </b-dropdown-item>									
                </b-dropdown>
              </b-col>
              <b-col sm="4" v-if="statusEditPrice">

                <b-dropdown right 
                            text="Opciones" 
                            variant="warning" 
                            size="sm"
                            class="btn-pill float-right ml-2" 
                            v-b-tooltip.hover 
                            title="Opciones de Edición" 
                            v-if="access.elements.changeProductsSale">                  
                  
                  <b-dropdown-item @click="showEditPriceLote()" v-if="itemSelected" title="Modifica el precio de lista de todos los productos filtrados">
                    <b-icon icon="percent"></b-icon> Edición general de precios
                  </b-dropdown-item>
                  <b-dropdown-item @click="showEditDiscountLote()" v-if="itemSelected" title="Agrega el mismo descuento a todos los productos filtrados">
                    <b-icon icon="segmented-nav"></b-icon> Edición general de descuentos
                  </b-dropdown-item>

                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="endChangePrice()" title="Finaliza el modo de edición de precios múltiples">
                    <b-icon icon="x-square"></b-icon> Finalizar edición múltiple
                  </b-dropdown-item>              
                </b-dropdown>
              </b-col>                
              <b-col sm="12" class="mt-2">

                <b-table class="mb-0"
                      style="min-height:180px;"
                      responsive
                      head-variant="dark"
                      :hover="true"
                      :small="true"
                      :fixed="true"
                      :items="table.items"
                      :fields="table.fields"
                      :filter="table.filter"
                      :current-page="table.currentPage"
                      :per-page="table.perPage"
                      :busy="table.isBusy"                     
                      v-if="(table.items && table.items.length) || table.isBusy">   
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template> 

                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Cargando...</strong>
                    </div>
                  </template>

                  <template v-slot:cell(code)="data">
                    <span :title="data.item.code">
                      <b-icon icon="exclude" 
                              variant="warning"
                              class="mr-2"
                              title="Producto no importado"
                              v-if="data.item.not_imported"
                              ></b-icon>
                      {{data.item.code}}
                    </span>                    
                  </template>

                  <template v-slot:cell(name)="data">
                    <span :title="data.item.name">
                      {{data.item.name}}
                    </span>
                    <b-icon icon="exclamation-diamond-fill" 
                            class="rounded-circle" 
                            variant="danger" 
                            title="No tiene relación con ningún Producto de Venta"
                            v-if="!data.item.products_id">
                    </b-icon>
                  </template>

                  <template v-slot:cell(category)="data">
                    <span :title="data.item.category + ' > ' + data.item.subcategory">
                      {{data.item.category}} > {{data.item.subcategory}}
                    </span>
                  </template>

                  <template v-slot:cell(unit_measurement)="data">   
                    <div :title="data.item.unit_measurement_purchase && data.item.unit_measurement_purchase.name">
                      {{ data.item.unit_measurement_purchase.reference }}
                    </div>
                  </template>

                  <template v-slot:cell(price_list)="data">
                    <div v-if="statusEditPrice && data.item.default">
                      <b-input-group size="sm" class="crud-products-customers-other">
                        <b-input-group-prepend is-text>{{getCurrencySymbol}}</b-input-group-prepend>                
                        <b-form-input aria-label="Precio de Lista" title="Precio de Lista" v-model="crud.prodTMP[data.index]['price_list']" type="number" step="0.01" min="0" v-on:keyup.enter.native="savePrice(crud.prodTMP[data.index])"></b-form-input>                      
                        <b-input-group-append>
                          <b-button variant="success" title="Confirmar" @click="savePrice(crud.prodTMP[data.index])">
                            <b-icon icon="check2" />
                          </b-button>
                        </b-input-group-append>                
                      </b-input-group>
                    </div>
                    <div v-else>                    
                      <b>
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.price_list)}}                                            
                      </b>
                    </div>
                  </template>

                  <template v-slot:cell(extra)="data">
                    <span v-if="data.item.additional">
                      + {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.additional)}}                                          
                    </span>                                        
                  </template>   

                  <template v-slot:cell(percentage_discount)="data">
                    <span v-if="getDiscount(data.item,1)"> -{{getDiscount(data.item,1)}} </span>
                    <span v-if="getDiscount(data.item,2)"> -{{getDiscount(data.item,2)}} </span>
                    <span v-if="getDiscount(data.item,3)"> -{{getDiscount(data.item,3)}} </span>
                    
                    <span v-if="getDiscount(data.item,1) || getDiscount(data.item,2) || getDiscount(data.item,3)">
                      %
                    </span>
                  </template>

                  <template v-slot:cell(additional)="data">
                    <span v-if="getAdditional(data.item,1)"> +{{getAdditional(data.item,1)}} </span>
                    <span v-if="getAdditional(data.item,2)"> +{{getAdditional(data.item,2)}} </span>                    
                    
                    <span v-if="getAdditional(data.item,1) || getAdditional(data.item,2)">
                      %
                    </span>
                  </template>

                  <template v-slot:cell(extra_1)="data">
                    <span v-if="data.item.additional_1">
                      + {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.additional_1)}}                                          
                    </span>                                        
                  </template>           

                  <template v-slot:cell(cost)="data">
                    <b>
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format( data.item.price_cost )}}                      
                    </b>
                  </template>    

                  <template v-slot:cell(default)="data">
                    <b-badge v-if="data.item.default" variant="dark">
                      SI
                    </b-badge>
                  </template>

                  <template v-slot:cell(last_update)="data">
                    <span v-if="diffLastUpdate(data.item) <= 15" variant="dark" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                      <b-icon icon="circle-fill" font-scale="1" variant="success"></b-icon>
                    </span>                    
                    <span v-if="diffLastUpdate(data.item) > 15 && diffLastUpdate(data.item) <= 30" variant="dark" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                      <b-icon icon="circle-fill" font-scale="1"  variant="warning"></b-icon>
                    </span>
                    <span v-if="diffLastUpdate(data.item) > 30" variant="dark" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                      <b-icon icon="circle-fill" animation="throb" font-scale="1" variant="danger"></b-icon>
                    </span>                    
                  </template>                                    
                                
                  <template v-slot:cell(f_action)="data">
                    <b-dropdown right text="" size="sm" variant="outline-dark" class="pull-right crud-price-list-suppliers-table-action">
                      <b-dropdown-item v-if="data.item.products_id" @click="showCompare(data.item)">
                        <i class="fa fa-columns ml-0 mr-0"></i> Comparar Precios
                      </b-dropdown-item>                                                        
                      <b-dropdown-item @click="showHistory(data.item)">
                        <i class="fa fa-history ml-0 mr-0"></i> Historial
                      </b-dropdown-item>
                      <b-dropdown-header v-if="access.elements.changeProductsSale">Acciones</b-dropdown-header>
                      <b-dropdown-item v-if="!data.item.default && access.elements.changeProductsSale" @click="setDefault(data.item)">
                        <i class="fa fa-dot-circle-o ml-0 mr-0"></i> Marcar Por Default
                      </b-dropdown-item>                                                 
                      <b-dropdown-item v-if="data.item.default && access.elements.changeProductsSale" @click="editProduct(data.item)">
                        <i class="fa fa-clone ml-0 mr-0"></i> Editar Producto
                      </b-dropdown-item>                      
                      <b-dropdown-divider v-if="access.elements.changeProductsSale" />
                      <b-dropdown-item @click="deleteProduct(data.item)" v-if="access.elements.changeProductsSale">
                        <i class="fa fa-trash ml-0 mr-0"></i> Eliminar Producto
                      </b-dropdown-item>                                            
                    </b-dropdown>
                  </template>
                </b-table>
                <b-alert show variant="info" v-else>
                  No hay productos para mostrar
                </b-alert>   

              </b-col>
              <b-col class="mt-4">
                <nav v-if="table.tablePaginate">
                  <b-pagination class="pull-right mb-0"
                                size="sm"
                                pills=""
                                :total-rows="table.tablePaginate.total"
                                :per-page="table.tablePaginate.per_page"
                                v-model="table.currentPage"
                                @input="selectedItem(filterQuery, true)" />
                </nav>                
              </b-col>              
            </b-row>
          </b-card>
        </b-col>
      </b-row> 

      <b-row>
        <b-col lg="12">  
          <b-card>
            <b-row>
              <b-col>
                <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                  <i class="fa fa-angle-double-left"></i>
                  Volver
                </b-button>                        
              </b-col>                      
            </b-row>
          </b-card>
        </b-col>
      </b-row>    

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD IMPORTACIONES -->
      <b-modal  v-model="modal.formImport.active"
                header-bg-variant="dark"
                header-text-variant="white"
                size="lg">
                
        <div slot="modal-header">          
          <Minimize />
          {{this.modal.formImport.title}}
        </div>
        
        <b-tabs pills card vertical>
          <b-tab title="Lista de Precios" @click="crud.formImport.type='import-costs-suppliers-products'" active >
            <b-card-text>
              <b-row>       
                <b-col md="12" class="mb-2">
                  <b-alert show variant="info">
                    <h4 class="alert-heading">Importación de Lista de Precio por Proveedor</h4>
                    
                    <div>
                      <b-icon icon="arrow-right-short"/> El sistema importará todos los registros cargados en el archivo.
                    </div>
                    <div>
                      <b-icon icon="arrow-right-short"/> Esta importación solo permite agregar <b>Productos de Proveedores</b>.
                    </div>                      
                    <div>
                      <b-icon icon="arrow-right-short"/> El <b>código de producto ingresado</b>, se vinculará con el <b>Producto Existente</b>, sino crea un <b>Producto Nuevo</b>.
                    </div>                    
                    <div>
                      <b-icon icon="arrow-right-short"/> Si el <b>producto inactivado</b> tiene una relación unica con un producto de venta, tambien lo <b>inactivará</b>.
                    </div>                                                            
                    <div>
                      <b-icon icon="arrow-right-short"/> En caso que el <b>producto de venta</b> tenga varios proveedores, solo se <b>inactivará</b> el producto para ese proveedor
                    </div>                                                                                
                    <div>
                      <b-icon icon="arrow-right-short"/> Es posible cargar una <b>utilidad diferencial</b> por <b>producto</b> para una <b>lista de precios</b>.
                    </div>                      

                    <hr>

                    <div class="mb-0">
                      Descargue el <a href="javascript:void(0);" @click="goDownloadFormat('examples-imports/costs/csv-format-costs-suppliers-products.csv')"><b>formato de ejemplo</b></a> para esta importación.
                    </div>                                                                  
                  </b-alert>    
                </b-col>
                <b-col md="12" class="mb-2">
                  <FindObject type="suppliers" 
                              @select-object="loadSuppliersImportCSV($event)" 
                              :valueID="crud.formImport.suppliers_id"
                              :where="conditionSuppliersActive"
                              render="search"/>                  
                </b-col>
                <b-col md="12" class="mb-2">                  
                  <b-form-group label="Archivo CSV [Lista de Precios]">                
                    <b-form-file v-model="crud.formImport.file"
                                  size="sm"
                                  :state="Boolean(crud.formImport.file)"
                                  placeholder="Elija un archivo o sueltelo aquí..."
                                  drop-placeholder="Suelta el archivo aquí...">
                    </b-form-file>                    
                  </b-form-group>         
                </b-col> 
                <b-col md="12" class="mb-2">                  
                  <b-form-group label="Tipo de Importación">                
                    <b-form-select v-model="crud.formImport.typeImport" :options="arr.select.typeImport" @input="changeTypeImportCSV()"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>              
            </b-card-text>
          </b-tab>
        </b-tabs>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formImport.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="importCSV()">Importar</b-button>          
        </div>

      </b-modal>

      <!-- HISTORIAL -->
      <b-modal v-model="modal.formHistory.active"
               header-bg-variant="dark"
               header-text-variant="white"
               size="lg">

        <div slot="modal-header">
          <Minimize />
          {{this.modal.formHistory.title}}
        </div>

        <b-row>
          <b-col lg="12">
            <b>{{this.itemSelectedHistory.toUpperCase()}}</b>
          </b-col>
          <b-col lg="12" class="cost-supplier-products-history-overflow">
            <b-table class="mb-0" 
                  responsive
                  head-variant="dark"
                  :hover="true"
                  :small="true"
                  :fixed="true"
                  :items="tableHistory.items"
                  :fields="tableHistory.fields"
                  :filter="tableHistory.filter"
                  :current-page="tableHistory.currentPage"
                  :per-page="tableHistory.perPage"
                  :busy="tableHistory.isBusy"                     
                  v-if="tableHistory.items.length || tableHistory.isBusy">   
                
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Cargando...</strong>
                </div>
              </template>

              <template v-slot:cell(date)="data">
                {{moment(data.item.date).format('DD/MM/YYYY')}}
              </template>

              <template v-slot:cell(unit_measurement)="data">   
                <div :title="data.item.unit_measurement_purchase && data.item.unit_measurement_purchase.name">
                  {{ data.item.unit_measurement_purchase.reference }}
                </div>
              </template>

              <template v-slot:cell(price_list)="data">
                <b>
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.price_list)}}                      
                </b>
              </template>

              <template v-slot:cell(extra)="data">
                <span v-if="data.item.additional">
                  + {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.additional)}}                                          
                </span>                                        
              </template>           

              <template v-slot:cell(percentage_discount)="data">
                <span v-if="getDiscount(data.item,1)"> -{{getDiscount(data.item,1)}} </span>
                <span v-if="getDiscount(data.item,2)"> -{{getDiscount(data.item,2)}} </span>
                <span v-if="getDiscount(data.item,3)"> -{{getDiscount(data.item,3)}} </span>
                
                <span v-if="getDiscount(data.item,1) || getDiscount(data.item,2) || getDiscount(data.item,3)">
                  %
                </span>
              </template>

              <template v-slot:cell(additional)="data">
                <span v-if="getAdditional(data.item,1)"> +{{getAdditional(data.item,1)}} </span>
                <span v-if="getAdditional(data.item,2)"> +{{getAdditional(data.item,2)}} </span>                    
                
                <span v-if="getAdditional(data.item,1) || getAdditional(data.item,2)">
                  %
                </span>
              </template>

              <template v-slot:cell(extra_1)="data">
                <span v-if="data.item.additional_1">
                  + {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.additional_1)}}                                          
                </span>                                        
              </template>           

              <template v-slot:cell(cost)="data">
                <b>
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format( data.item.price_cost )}}                      
                </b>
              </template>    
            </b-table>
            <b-alert show variant="info" v-else>
              No se encontró el historial
            </b-alert>               
          </b-col>
        </b-row>  

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="closeHistory()">Cerrar</b-button>
        </div>                     
      </b-modal>

      <!-- CONVERSION -->
      <b-modal v-model="modal.formConvert.active"
               header-bg-variant="dark"
               header-text-variant="white"
               size="lg">

        <div slot="modal-header">
          <Minimize />
          {{this.modal.formConvert.title}}
        </div>

        <b-tabs card>
          <b-tab no-body title="General">
            <b-row>
              <b-col lg="12" v-if="this.itemSelectedConvert">
                <b>{{this.itemSelectedConvert.toUpperCase()}}</b>
              </b-col>
              <b-col lg="12">
                <b-form-radio-group
                  v-model="crud.formConvert.type"
                  :options="arr.typeConvert"
                  class="mb-3"
                  value-field="item"
                  text-field="name"
                  @input="changeTypeConvert()"  
                  :disabled="!crud.formConvert.changeType"            
                ></b-form-radio-group>            
              </b-col>
              <b-col lg="12" v-if="!this.itemSelectedConvert">
                <FindObject type="suppliers" 
                            @select-object="loadSuppliersAddProduct($event)" 
                            tag="Proveedor"
                            :valueID="crud.formConvert.suppliers_id"
                            :where="conditionSuppliersActive"
                            render="search"/>  
              </b-col>              
              <b-col lg="12">
                <b-row>
                  <b-col lg="4">
                    <b-form-group label="Código">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.formConvert.code"
                                    placeholder="Ingresar un código">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="8">
                    <b-form-group label="Nombre">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.formConvert.name"
                                    placeholder="Ingresar un nombre">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group label="Categoría">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.formConvert.category"
                                    placeholder="Ingresar una categoría">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group label="Subcategoría">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.formConvert.subcategory"
                                    placeholder="Ingresar una subcategoría">
                      </b-form-input>
                    </b-form-group>
                  </b-col>         
                  <b-col lg="6" v-if="hasLines">
                    <b-form-group label="Línea">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.formConvert.line"
                                    placeholder="Ingresar una linea">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6" v-if="hasLines">
                    <b-form-group label="Sublínea">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.formConvert.subline"
                                    placeholder="Ingresar una subline">
                      </b-form-input>
                    </b-form-group>
                  </b-col>                           
                  <b-col lg="12">
                    <b-form-group label="Código de Barra">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.formConvert.barcode"
                                    placeholder="Ingresar un código de barra">
                      </b-form-input>
                    </b-form-group>          
                  </b-col>                                                     
                </b-row>
              </b-col>            
            </b-row>
          </b-tab>
          <b-tab no-body title="Precio">        
            <b-row>
              <b-col lg="5">
                <b-form-group :label="'Precio de Lista ($)'">
                  <b-form-input type="number"
                                size="sm"
                                step="0.01"
                                v-model="crud.formConvert.price_list"
                                placeholder="Precio de Lista">
                  </b-form-input>            
                </b-form-group>
              </b-col>                  
            </b-row>
          </b-tab>
          <b-tab no-body title="+ ($)">
            <b-row>
              <b-col lg="12">
                <b-form-group :label="'Adicional ($)'" description="Se calcula sobre el precio de lista">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.formConvert.additional"
                                placeholder="Adicional">
                  </b-form-input>            
                </b-form-group>
              </b-col>  
            </b-row>            
          </b-tab>
          <b-tab no-body title="- (%)">
            <b-row>
              <b-col lg="12">
                <b-row>
                  <b-col lg="4">
                    <b-form-group :label="'Descuento 1 (%)'">
                      <b-form-input type="number"
                                    size="sm"
                                    v-model="crud.formConvert.percentage_discount"
                                    placeholder="Descuento">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>
                  <b-col lg="4">
                    <b-form-group :label="'Descuento 2 (%)'">
                      <b-form-input type="number"
                                    size="sm"
                                    v-model="crud.formConvert.percentage_discount_1"
                                    placeholder="Descuento">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>
                  <b-col lg="4">
                    <b-form-group :label="'Descuento 3 (%)'">
                      <b-form-input type="number"
                                    size="sm"
                                    v-model="crud.formConvert.percentage_discount_2"
                                    placeholder="Descuento">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>              
            </b-row>
          </b-tab>
          <b-tab no-body title="+ (%) + ($)">
            <b-row>
              <b-col lg="12">
                <b-row>                      
                  <b-col lg="6">
                    <b-form-group :label="'Adiccional 1 (%)'">
                      <b-form-input type="number"
                                    size="sm"
                                    v-model="crud.formConvert.additional_percentage"
                                    placeholder="Adiccional">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group :label="'Adiccional 2 (%)'">
                      <b-form-input type="number"
                                    size="sm"
                                    v-model="crud.formConvert.additional_percentage_1"
                                    placeholder="Adiccional">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>              
                  <b-col lg="12">
                    <b-form-group :label="'Adicional ($)'" description="Se calcula sobre el precio final [precio de lista + adiccional ($) - descuentos (%) + adiccional (%)]">
                      <b-form-input type="number"
                                    size="sm"
                                    v-model="crud.formConvert.additional_1"
                                    placeholder="Adicional">
                      </b-form-input>            
                    </b-form-group>
                  </b-col>      
                </b-row>
              </b-col> 
            </b-row>
          </b-tab>  
          <b-tab no-body title="Atributos" v-if="hasMeasurement">
            <b-row>
              <b-col md="12">
                <b-form-group label="Profundidad" description="Ingrese la medida en cm">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.formConvert.depth"
                                required
                                placeholder="Ingresar una profundidad">
                  </b-form-input>
                </b-form-group>
              </b-col>    
              <b-col md="12">
                <b-form-group label="Largo" description="Ingrese la medida en cm">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.formConvert.long"
                                required
                                placeholder="Ingresar un largo">
                  </b-form-input>
                </b-form-group>
              </b-col>    
              <b-col md="12">
                <b-form-group label="Alto" description="Ingrese la medida en cm">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.formConvert.height"
                                required
                                placeholder="Ingresar un alto">
                  </b-form-input>
                </b-form-group>
              </b-col> 
              <b-col md="12">
                <b-form-group label="Peso" description="Ingrese el peso en kg">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.formConvert.weight"
                                required
                                placeholder="Ingresar un peso">
                  </b-form-input>
                </b-form-group>
              </b-col>                   
            </b-row>
          </b-tab>                  
          <b-tab no-body title="U.Medidas">
            <b-row>
              <b-col lg="8">
                <FindObject type="unitMeasurement" 
                            tag="Unidad de Medida de Compra"
                            @select-object="loadUnitMeasurementPurchase($event)" 
                            :valueID="crud.formConvert.unit_measurement_purchase_id"
                            render="search"/>                       
              </b-col>              
              <b-col lg="8">
                <FindObject type="unitMeasurement" 
                            tag="Unidad de Medida de Venta"
                            @select-object="loadUnitMeasurementSale($event)" 
                            :valueID="crud.formConvert.unit_measurement_sale_id"
                            render="search"/>                       
              </b-col>
              <b-col lg="4" v-if="crud.formConvert.unit_measurement_purchase_id != crud.formConvert.unit_measurement_sale_id">
                <b-form-group label="Variable" description="Variable de Conversión">
                  <b-form-input type="number"
                                size="sm"
                                step="0.01"
                                v-model="crud.formConvert.unit_measurement_sale_conversion"
                                placeholder="Ingrese un valor">
                  </b-form-input>            
                </b-form-group>
              </b-col>                  
            </b-row>
          </b-tab>            
          <b-tab no-body title="Fiscal" v-if="isProcessSales">
            <b-row>
              <b-col lg="12">
                <FindObject render="search"
                            type="erpIvaConditions" 
                            @select-object="loadIvaConditions($event)" 
                            :valueID="crud.formConvert.iva_condition_id"/>
              </b-col>              
            </b-row>            
          </b-tab>                       
          <b-tab no-body title="Listas de Precios">
            <b-row>
              <b-col lg="12" :key="convertPriceForceUpdateKey" class="cost-supplier-products-edit-overflow">
                <b-row v-for="element in arr.listPrices" :key="element.id">
                  <b-col lg="5">
                    <div class="mt-3">
                      <b>Lista:</b> {{element.name}} ({{element.reference}}) <br>
                      <b>Defecto:</b> {{Intl.NumberFormat('es-AR',{style:'percent'}).format( getUtility(element) )}}
                    </div>
                  </b-col>
                  <b-col lg="7" v-if="crud.formConvert.lists[element.id]">
                    <b-row>
                      <b-col lg="6">
                        <b-form-group :label="'Utilidad'">
                          <b-form-input type="number"
                                        size="sm"
                                        v-model="crud.formConvert.lists[element.id]['utility']"
                                        placeholder="Ingresar utilidad diferencial para esta lista">
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col lg="6">
                        <b-form-group :label="'Descuento'">
                          <b-form-input type="number"
                                        size="sm"
                                        v-model="crud.formConvert.lists[element.id]['desc']"
                                        placeholder="Ingresar el descuento para esta lista">
                          </b-form-input>
                        </b-form-group>
                      </b-col>                  
                    </b-row>
                  </b-col>
                  <b-col lg="12">
                    <hr class="mt-0 mb-2">
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>                    

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formConvert.active=false">Cerrar</b-button>
          <b-button variant="dark" @click="saveProduct()">GUARDAR</b-button>        
        </div>                     
      </b-modal>

      <!-- COMPARE PRICE -->
      <b-modal v-model="modal.formCompare.active"
               header-bg-variant="dark"
               size="xl"
               header-text-variant="white">

        <div slot="modal-header">
          <Minimize />
          {{this.modal.formCompare.title}}
        </div>

        <b-row>
          <b-col lg="12">
            <b>{{this.itemSelectedCompare.toUpperCase()}}</b>
          </b-col>
          <b-col lg="12">
            <b-table class="mb-0" 
                  responsive
                  head-variant="dark"
                  :hover="true"
                  :small="true"
                  :fixed="true"
                  :items="tableCompare.items"
                  :fields="tableCompare.fields"
                  :filter="tableCompare.filter"
                  :current-page="tableCompare.currentPage"
                  :per-page="tableCompare.perPage"
                  :busy="tableCompare.isBusy"                     
                  v-if="tableCompare.items.length || tableCompare.isBusy">   
                
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Cargando...</strong>
                </div>
              </template>

              <template v-slot:cell(supplier)="data">
                {{data.item.supplier.name}}
              </template>

              <template v-slot:cell(unit_measurement)="data">   
                <div :title="data.item.unit_measurement_purchase && data.item.unit_measurement_purchase.name">
                  {{ data.item.unit_measurement_purchase.reference }}
                </div>
              </template>

              <template v-slot:cell(price_list)="data">
                <b>
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.price_list)}}                      
                </b>
              </template>

              <template v-slot:cell(extra)="data">
                <span v-if="data.item.additional">
                  + {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.additional)}}                                          
                </span>                                        
              </template>   

              <template v-slot:cell(percentage_discount)="data">
                <span v-if="getDiscount(data.item,1)"> -{{getDiscount(data.item,1)}} </span>
                <span v-if="getDiscount(data.item,2)"> -{{getDiscount(data.item,2)}} </span>
                <span v-if="getDiscount(data.item,3)"> -{{getDiscount(data.item,3)}} </span>
                
                <span v-if="getDiscount(data.item,1) || getDiscount(data.item,2) || getDiscount(data.item,3)">
                  %
                </span>
              </template>

              <template v-slot:cell(additional)="data">
                <span v-if="getAdditional(data.item,1)"> +{{getAdditional(data.item,1)}} </span>
                <span v-if="getAdditional(data.item,2)"> +{{getAdditional(data.item,2)}} </span>                    
                
                <span v-if="getAdditional(data.item,1) || getAdditional(data.item,2)">
                  %
                </span>
              </template>        

              <template v-slot:cell(extra_1)="data">
                <span v-if="data.item.additional_1">
                  + {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format(data.item.additional_1)}}                                          
                </span>                                        
              </template>   

              <template v-slot:cell(cost)="data">
                <b>
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency }).format( data.item.price_cost )}}                      
                </b>
              </template>    

              <template v-slot:cell(default)="data">
                <b-badge v-if="data.item.default" variant="dark">
                  SI
                </b-badge>
              </template>

              <template v-slot:cell(last_update)="data">
                <span v-if="diffLastUpdate(data.item) <= 15" variant="dark" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                  <b-icon icon="circle-fill" font-scale="1" variant="success"></b-icon>
                </span>                    
                <span v-if="diffLastUpdate(data.item) > 15 && diffLastUpdate(data.item) <= 30" variant="dark" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                  <b-icon icon="circle-fill" font-scale="1"  variant="warning"></b-icon>
                </span>
                <span v-if="diffLastUpdate(data.item) > 30" variant="dark" v-b-tooltip.hover :title="'Última Atualización: ' + diffLastUpdate(data.item) + ' día/s'">
                  <b-icon icon="circle-fill" animation="throb" font-scale="1" variant="danger"></b-icon>
                </span>                    
              </template>               
            </b-table>
            <b-alert show variant="info" v-else>
              No se encontró ningún producto
            </b-alert>               
          </b-col>
        </b-row>  

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="closeCompare()">Cerrar</b-button>
        </div>                     
      </b-modal>      

      <!-- MODIFICACION PRECIOS LOTE -->
      <b-modal v-model="modal.formEditPriceLote.active"
               header-bg-variant="dark"
               header-text-variant="white">

        <div slot="modal-header">
          <Minimize />
          {{this.modal.formEditPriceLote.title}}
        </div>

        <b-row>
          <b-col lg="12">
            <b-alert show variant="info">
              Esta modificación de PRECIOS afectará a todos los productos filtrados y que estan agrupados por <b>"{{this.itemSelected}}"</b>.
            </b-alert>
          </b-col>
        </b-row>  
        <b-row>
          <b-col lg="6">
            <b-form-group :label="'Porcentaje Aumento (%)'">
              <b-input-group size="sm" append="%">                            
                <b-form-input type="number"                              
                              step="0.01"
                              v-model="crud.formEditPriceLote.percentage"
                              placeholder="Porcentaje"
                              style="padding-left: 0.5rem;">
                </b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>                                        
        </b-row>  

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="closeEditPriceLote()">Cerrar</b-button>
          <b-button variant="dark" @click="saveEditPriceLote()">ACTUALIZAR</b-button>        
        </div>                     
      </b-modal> 

      <!-- MODIFICACION DESCUENTO LOTE -->
      <b-modal v-model="modal.formEditDiscountLote.active"
               header-bg-variant="dark"
               size="lg"
               header-text-variant="white">

        <div slot="modal-header">
          <Minimize />
          {{this.modal.formEditDiscountLote.title}}
        </div>

        <b-row>
          <b-col lg="12">
            <b-alert show variant="info">
              Esta modificación de DESCUENTOS afectará a todos los productos filtrados y que estan agrupados por <b>"{{this.itemSelected}}"</b>.
            </b-alert>
          </b-col>  
        </b-row>  

        <b-row>
          <b-col lg="4">
            <b-form-group :label="'Descuento 1 (%)'">
              <b-input-group size="sm" append="%">                            
                <b-form-input type="number"
                              v-model="crud.formEditDiscountLote.discount1"
                              placeholder="Descuento"
                              style="padding-left: 0.5rem;">
                </b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group :label="'Descuento 2 (%)'">
              <b-input-group size="sm" append="%">                            
                <b-form-input type="number"
                              v-model="crud.formEditDiscountLote.discount2"
                              placeholder="Descuento"
                              style="padding-left: 0.5rem;">
                </b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group :label="'Descuento 3 (%)'">
              <b-input-group size="sm" append="%">                            
                <b-form-input type="number"                              
                              v-model="crud.formEditDiscountLote.discount3"
                              placeholder="Descuento"
                              style="padding-left: 0.5rem;">
                </b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>        
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="closeEditDiscountLote()">Cerrar</b-button>
          <b-button variant="dark" @click="saveEditDiscountLote()">ACTUALIZAR</b-button>        
        </div>                     
      </b-modal>                  
    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'  
  import Funciones from '@/handler/funciones' 
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'   
  import FindObject from '@/components/inc/find/findObject'
  import Minimize from '@/components/inc/modal/minimize'
  import moment from 'moment'      
  import Param from '@/config/parameters'  

  import Vue from 'vue'
  import { VueTreeList, Tree, TreeNode } from 'vue-tree-list'
  Vue.use(VueTreeList)  

  export default {
    components: {
      FindObject,
      VueTreeList,
      Minimize,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.COSTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudPriceListSuppliers',
          elements: {
            changeProductsSale: true,
          }
        }, 
        parameters: {
          haveLines: Helper.hasParametersAccess(Param.P7),          
          haveMeasurement: Helper.hasParametersAccess(Param.P10),
        },        
        table : {
          items: [],
          fields: [                       
            {key: 'code', label: 'Código', class:'text-left align-middle text-truncate', width:"7%"},
            {key: 'name', label: 'Nombre', class:'text-left align-middle text-truncate', width:"20%"},                        
            {key: 'unit_measurement', label: 'U.Med.', class:'text-center align-middle text-truncate', width:"5%"},            
            {key: 'price_list', label: 'Lista', class:'text-right align-middle', width:"9%"},
            {key: 'extra', label: '+ ($)', class:'text-right align-middle', width:"10%"},
            {key: 'percentage_discount', label: '- (%)', class:'text-right align-middle', width:"10%"},
            {key: 'additional', label: '+ (%)', class:'text-right align-middle', width:"10%"},
            {key: 'extra_1', label: '+ ($)', class:'text-right align-middle', width:"10%"},
            {key: 'cost', label: 'Compra', class:'text-right align-middle', width:"9%"},
            {key: 'last_update', label: '', class:'text-center align-middle', width:"2%"},
            {key: 'default', label: 'Default', class:'text-center align-middle', width:"5%"},            
            {key: 'f_action', label:'', class:'text-right align-middle', width:"3%"},
          ],          
          filter: null,
          mostrarFiltros: false,
          tablePaginate: null,
          currentPage: 1,
          perPage: 0,
          isBusy: false,          
        },   
        tableHistory: {
          items: [],
          fields: [            
            {key: 'date', label: 'Fecha', class:'text-left align-middle', width:"15%"},
            {key: 'unit_measurement', label: 'U.Med.', class:'text-center align-middle text-truncate', width:"5%"},            
            {key: 'price_list', label: 'Lista', class:'text-right align-middle', width:"10%"},            
            {key: 'extra', label: '+ ($)', class:'text-right align-middle', width:"15%"},
            {key: 'percentage_discount', label: '- (%)', class:'text-right align-middle', width:"15%"},
            {key: 'additional', label: '+ (%)', class:'text-right align-middle', width:"15%"},
            {key: 'extra_1', label: '+ ($)', class:'text-right align-middle', width:"15%"},
            {key: 'cost', label: 'Compra', class:'text-right align-middle', width:"10%"},
          ],        
          tablePaginate: true,
          currentPage: 1,
          perPage: 50,
          isBusy: false,          
        },
        tableCompare: {
          items: [],
          fields: [            
            {key: 'supplier', label: 'Proveedor', class:'text-left align-middle text-truncate', width:"15%"},
            {key: 'unit_measurement', label: 'U.Med.', class:'text-center align-middle text-truncate', width:"5%"},            
            {key: 'price_list', label: 'Lista', class:'text-right align-middle', width:"10%"},                        
            {key: 'extra', label: '+ ($)', class:'text-right align-middle', width:"10%"},
            {key: 'percentage_discount', label: '- (%)', class:'text-right align-middle', width:"15%"},
            {key: 'additional', label: '+ (%)', class:'text-right align-middle', width:"15%"},
            {key: 'extra_1', label: '+ ($)', class:'text-right align-middle', width:"10%"},
            {key: 'cost', label: 'Compra', class:'text-right align-middle', width:"10%"},            
            {key: 'last_update', label: '', class:'text-center align-middle', width:"5%"},            
            {key: 'default', label: 'Default', class:'text-center align-middle', width:"5%"},
          ],        
          tablePaginate: true,
          currentPage: 1,
          perPage: 50,
          isBusy: false,          
        },             
        crud: {          
          formImport: {
            suppliers: null,
            suppliers_id: 0,
            typeImport: 'default',
            file: '',
            type: ''            
          },
          formConvert: {
            id: 0,
            type: 'NUEVO',
            barcode: '',
            code: '',
            name: '',
            category: '',
            subcategory: '',
            line: '',
            subline: '',            
            products_id: 0,
            products: null,
            changeType: false,
            lists: [],
            price_list: 0,
            percentage_discount: 0,
            percentage_discount_1: 0,
            percentage_discount_2: 0,
            additional: 0,
            additional_1: 0,
            additional_percentage: 0,
            additional_percentage_1: 0,
            unit_measurement_purchase_id: 0,
            unit_measurement_purchase: null,
            unit_measurement_sale_id: 0,
            unit_measurement_sale: null,            
            unit_measurement_sale_conversion: 0,   
            suppliers_id: 0,       
            depth: 0,
            long: 0,
            height: 0,
            weight: 0,
            iva_condition: null,
            iva_condition_id: 0,
          },
          formEditPriceLote: {
            percentage: 0,
            operations: '+',
            filterQuery: []
          },
          formEditDiscountLote: {
            discount1: 0,
            discount2: 0,
            discount3: 0,
            filterQuery: []
          },          
          prodTMP: [],
        },                      
        arr: {
          listProducts: [],
          listPrices: [],
          export: [],
          typeConvert: [
            { item: 'NUEVO', name: 'Nuevo Producto' },
            { item: 'EDITAR', name: 'Editar Producto' },
          ],          
          filters : {
            suppliers: [],            
          }, 
          select: {
            linkedProduct:[
              {code:true, label: 'Vinculados'},
              {code:false, label: 'Sin Vincular'},              
            ],               
            lastUpdate:[
              {code:'0-15', label: 'Últimos 15 días'},
              {code:'15-30', label: 'Entre 15 y 30 días'},
              {code:'30-9999', label: 'Mas de 30 días'},              
            ],  
            notImported:[
              {code:true, label: 'Importados'},
              {code:false, label: 'No Importados'},              
            ],                           
            typeImport:[
              {value:'default', text: 'Actualiza solo los productos importados'},
              {value:'warning', text: 'Marca los productos que no se importaron en la lista'},
              {value:'delete', text: 'Elimina los productos que no se importaron en la lista'},              
            ],                                       
          }                               
        },           
        filters: {
          suppliers: null,
        },  
        filterQuery: {
          suppliers_id: 0,
          category: '',
          subcategory: '',
          text: '',
          linkedProduct: null,
          lastUpdate: null,
          notImported: null,
          paginate: true,
        }, 
        modal: {
          formImport: {
            active: false,
            title: ''
          },
          formHistory: {
            active: false,
            title: ''            
          },
          formConvert: {
            active: false,
            title: ''                        
          },
          formCompare: {
            active: false,
            title: ''
          },    
          formEditPriceLote: {
            active: false,
            title: ''
          },
          formEditDiscountLote: {
            active: false,
            title: ''            
          }
        }, 
        convertPriceForceUpdateKey: 0,
        itemSelected: '',
        itemSelectedHistory: '',
        itemSelectedConvert: '',
        itemSelectedCompare: '',
        suppliers: null,
        suppliersTree: new Tree([]),       
        statusEditPrice: false,  
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.changeProductsSale = Helper.hasAccessElement(this.access, 'change_products_sale')       
      /* Fin configuracion */
    },     
    mounted() {         
      this.loadSuppliers()         
      this.filterLoad()      
      this.loadListsPrices()
    },     
    computed: {
      getCurrency() {
        return 'ARS'
      },
      getCurrencySymbol() {
        return '$'
      },

      // CONDITIONS SELECT
      conditionSuppliersActive(){
        return [
          {field: 'active', condition: true},
          {field: 'shipping', condition: false}
        ];
      },        
      
      // PARAMETROS
      hasLines() {
        return this.parameters.haveLines
      },
      hasMeasurement() {        
        return this.parameters.haveMeasurement
      },      
      isProcessSales() {
        var status = false
        var modulesActive = Session.getSession().auth.user.permissions.modules
        modulesActive.forEach(element => {
          if(element.id == Modules.VENTAS || element.id == Modules.PRESUPUESTOS) {
            status = true
          }
        })
        return status
      },       
    },      
    methods: {
      // IMPORT BY CSV
      openImportCSV() {
        this.crud.formImport.type = 'import-costs-suppliers-products'
        this.crud.formImport.file = ''        
        this.crud.formImport.typeImport = 'default'
        this.crud.formImport.suppliers_id= (this.filterQuery['suppliers_id'] != undefined) ? this.filterQuery['suppliers_id'] : 0
        this.crud.formImport.suppliers= null
            
        this.modal.formImport.title = "Gestor de Importaciones"
        this.modal.formImport.active = true
      },
      importCSV() {     
        var message = '¿Continuar con la importación?'
        if(this.crud.formImport.typeImport == 'warning') {
          message = 'El proceso marcará aquellos productos que no se encuentran en el archivo, ¿Continuar con la importación?'
        } 
        if(this.crud.formImport.typeImport == 'delete') {
          message = 'El proceso ELIMINARÁ aquellos productos que no se encuentran en el archivo, ¿Continuar con la importación?'
        }
        

        this.$bvModal.msgBoxConfirm(message, {
          title: 'Importar desde CSV',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'dark',
          okTitle: 'IMPORTAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {          
          if (value) {            
            let loader = this.$loading.show();

            var file = new FormData();
            file.append("file", this.crud.formImport.file);            
              
            var result = serviceAPI.importarSuppliersProductosPrices(JSON.stringify(this.crud.formImport), file);

            result.then((response) => {              
              this.modal.formImport.active = false              
              loader.hide()
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)
              this.$awn.success("Archivo importado con éxito");
            })
            .catch(error => {               
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {             
          this.$awn.alert(Error.showError(error));
        })        
      },
      goDownloadFormat(value) {
        var win = window.open(Helper.getPathPublic(value), '_blank');        
        win.focus();
      },
      loadSuppliersImportCSV(object) {
        if(object){
          this.crud.formImport.suppliers = object
          this.crud.formImport.suppliers_id = object.id
        } else {
          this.crud.formImport.suppliers = null
          this.crud.formImport.suppliers_id = 0
        }
      },
      changeTypeImportCSV() {
        if(this.crud.formImport.typeImport == 'warning'){          
          this.$bvModal.msgBoxOk('Se marcarán todos los productos que no se agregaron al archivo. Se verificará en toda la lista del proveedor seleccionado', {
            title: 'ATENCIÓN!!! Importación de Productos por Proveedor',
            size: 'md',
            buttonSize: 'sm',            
            okVariant: 'warning',            
            headerBgVariant: 'warning',
            bodyBgVariant: 'light',
            footerBgVariant: 'light',            
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          })
        } 
        
        if(this.crud.formImport.typeImport == 'delete'){          
          this.$bvModal.msgBoxOk('Se eliminarán todos los productos que no se agregaron al archivo. Se verificará en toda la lista del proveedor seleccionado', {
            title: 'ATENCIÓN!!! Importación de Productos por Proveedor',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            headerBgVariant: 'danger',
            bodyBgVariant: 'light',
            footerBgVariant: 'light',            
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          })          
        }
      },

      // FILTER
      filterLoad() {   
        this.filterLoadSuppliers()          
      },
      filterLoadSuppliers() {
        var result = serviceAPI.obtenerProveedoresOnlyImport()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.suppliers = []
          data.forEach(element => {   
            if(element.active && !element.shipping) {
              this.arr.filters.suppliers.push({ code: element.id, label: element.name })            
            }
          });          
        })   
      },      

      // TREE
      loadSuppliers() {
        let loader = this.$loading.show()   
   
        var result = serviceAPI.obtenerProveedoresForTree(this.filters)
        result.then((response) => {
          loader.hide()
          
          this.arr.listProducts = [];
          this.suppliers = [];  
          this.suppliersTree = new Tree(this.suppliers);  

          var data = response.data                 
          if(Object.entries(data).length) {
            var arrSuppliers = []
            Object.entries(data).forEach(([key, element]) => {            
              arrSuppliers.push({
                id: element.id,
                name: element.name,
                category: element.category,
                subcategory: element.subcategory,
              })
            });
                          
            arrSuppliers = Funciones.sortArrayInteger(arrSuppliers,'id','asc')              
            
            var groupCat = []            
            arrSuppliers.forEach(element => {
              if(groupCat[element.id] == undefined) {
                groupCat[element.id] = []                 
                groupCat[element.id].id = element.id    
                groupCat[element.id].name = element.name    
                groupCat[element.id].children = []            
              }
            });            
            groupCat = groupCat.filter(Boolean)

            this.configTree(groupCat, arrSuppliers)
          }           
        })
        .catch(error => {         
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });         
      },      
      configTree(group, data) {               
        this.suppliers = []             

        group.forEach((element, index) => {                                
          this.suppliers.push({            
            id: element.id,                  
            name: element.name,            
            dragDisabled: true,
            addTreeNodeDisabled: true,
            addLeafNodeDisabled: true,
            editNodeDisabled: true,
            delNodeDisabled: true,                     
            children: this.getChildrenCat(element.id, data),
          })       
        })                  

        this.suppliersTree = new Tree(this.suppliers)                
      },
      getChildrenCat(supplier_id, data) {                
        var arrChildrenCat = []
        if(data) {        
          var catSupplier = []
          data.forEach((element, index) => {   
            if(element.id == supplier_id) {
              catSupplier.push(element)
            }
          });
          var arrCat = Funciones.groupBy(catSupplier, (item)=>{return item.category})          

          arrCat.forEach((element, index) => {                         
            arrChildrenCat.push({                   
              id: element[0].category,      
              name: element[0].category,                
              dragDisabled: true,
              addTreeNodeDisabled: true,
              addLeafNodeDisabled: true,
              editNodeDisabled: true,
              delNodeDisabled: true,                  
              isLeaf: false,      
              children: this.getChildrenSubcat(element),                      
            })            
          });     
        }         
        return arrChildrenCat
      },
      getChildrenSubcat(data) {                                       
        var arrChildrenSubcat = []
        if(data) {        
          data.forEach((element, index) => {                             
            arrChildrenSubcat.push({    
              id: element.subcategory,      
              name: element.subcategory,                
              dragDisabled: true,
              addTreeNodeDisabled: true,
              addLeafNodeDisabled: true,
              editNodeDisabled: true,
              delNodeDisabled: true,                  
              isLeaf: true,                            
            })                
          });     
        } 
        return arrChildrenSubcat  
      },      
      selectedItem(params, forceSelected=false, forceBusy=true, msjDefault = '') {              
        this.table.isBusy = forceBusy

        if(!forceSelected) {
          this.filterQuery = null
          if(params.parent.id) {
            if(params.isLeaf) {              
              this.filterQuery = {
                suppliers_id: params.parent.parent.id,
                category: params.parent.name,
                subcategory: params.name
              }              
              this.itemSelected = params.parent.parent.name.toUpperCase() + ' > ' + params.parent.name.toUpperCase() + ' > ' + params.name.toUpperCase()

            } else {              
              this.filterQuery = {
                suppliers_id: params.parent.id,
                category: params.name
              }              
              this.itemSelected = params.parent.name.toUpperCase() + ' > ' + params.name.toUpperCase()
            }
            
          } else {
            this.filterQuery = {
              suppliers_id: params.id,          
            }

            this.itemSelected = params.name.toUpperCase()
          }   
        }

        this.filterQuery.paginate = true
        var result = serviceAPI.obtenerProductsByFilter(this.filterQuery, this.table.currentPage)        
        result.then((response) => {          
          var data = response.data       
          this.table.tablePaginate = data      
          this.table.items = data.data

          if(this.table.items) {
            this.table.items.forEach((element, index) => {
              if(!this.crud.prodTMP[index])
                this.crud.prodTMP[index] = []
              
              this.crud.prodTMP[index] = {
                id: element.id,            
                product_id: element.products_id,                                
                price_list: element.price_list ? element.price_list : 0,
              }            
            })
          }
          
          this.table.isBusy = false

          if(msjDefault)
            this.$awn.info(msjDefault)          
        })
      },    
      prepareExport() {                
        this.$bvModal.msgBoxConfirm('¿Descargar lista de precios de los productos del proveedor seleccionado?', {
          title: 'Descargar lista de precios',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'dark',
          okTitle: 'GENERAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {          
          if (value) {          
            this.$awn.info("Estamos procesando el archivo, por favor espere...");
            let loader = this.$loading.show();

            this.arr.export = []        
            
            this.filterQuery.paginate = false
            var result = serviceAPI.obtenerProductsByFilter(this.filterQuery, null)        
            result.then((response) => {              
              this.arr.listProducts = response.data
                                
              if(this.arr.listProducts.length) {                
                this.arr.listProducts.forEach(element => { 

                  var arrExport = []
                  arrExport['code'] = element.code
                  arrExport['name'] = element.name
                  arrExport['category'] = element.category
                  arrExport['subcategory'] = element.subcategory
                  arrExport['line'] = element.line
                  arrExport['subline'] = element.subline
                  arrExport['depth'] = parseFloat(element.depth).toFixed(2).replace('.',',')
                  arrExport['long'] = parseFloat(element.long).toFixed(2).replace('.',',')
                  arrExport['height'] = parseFloat(element.height).toFixed(2).replace('.',',')
                  arrExport['weight'] = parseFloat(element.weight).toFixed(2).replace('.',',')
                  arrExport['unit_measurement_purchase'] = element.unit_measurement_purchase.reference
                  arrExport['unit_measurement_sale'] = ''
                  arrExport['unit_measurement_sale_conversion'] = ''
                  arrExport['iva_condition'] = parseInt(element.iva_condition)
                  arrExport['code_system'] = ''
                  arrExport['barcode'] = ''
                  arrExport['default'] = element.default
                  arrExport['price_list'] = parseFloat(element.price_list).toFixed(2).replace('.',',')
                  arrExport['additional'] = parseFloat(element.additional).toFixed(2).replace('.',',')
                  arrExport['percentage_discount'] = parseFloat(element.percentage_discount).toFixed(2).replace('.',',')
                  arrExport['percentage_discount_1'] = parseFloat(element.percentage_discount_1).toFixed(2).replace('.',',')
                  arrExport['percentage_discount_2'] = parseFloat(element.percentage_discount_2).toFixed(2).replace('.',',')
                  arrExport['additional_percentage'] = parseFloat(element.additional_percentage).toFixed(2).replace('.',',')
                  arrExport['additional_percentage_1'] = parseFloat(element.additional_percentage_1).toFixed(2).replace('.',',')
                  arrExport['additional_1'] = parseFloat(element.additional_1).toFixed(2).replace('.',',')
                  
                  if(element.product) {
                    arrExport['code_system'] = element.product.code
                    arrExport['barcode'] = element.product.barcode
                    
                    if(element.product.unit_measurement_sale) {                
                      arrExport['unit_measurement_sale'] = element.product.unit_measurement_sale.reference
                      arrExport['unit_measurement_sale_conversion'] = parseInt(element.product.unit_measurement_sale_conversion)
                    }

                    if(element.product.prices.length > 0) {     
                      element.product.prices.forEach(element1 => {
                        arrExport['utility_' + element1.list.reference] = parseFloat(element1.utility).toFixed(2).replace('.',',')
                        arrExport['desc_' + element1.list.reference] = parseFloat(element1.desc).toFixed(2).replace('.',',')
                      });
                    } else {
                      this.arr.listPrices.forEach(element1 => {
                        arrExport['utility_' + element1.reference] = 0
                        arrExport['desc_' + element1.reference] = 0
                      });
                    }
                  } 
                                
                  this.arr.export.push(arrExport)
                });                 
                                
                loader.hide()
                this.$awn.success("Finalizamos el proceso, descargando archivo...");

                Funciones.exportToCSV(this.arr.export, 'list-cost-products')
              }
            })
            .catch(error => {                 
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })          
          }
        })
        .catch(error => {                                     
          this.$awn.alert(Error.showError(error));
        })              
      },

      // TABLA
      getRowCount (items) {
        return items.length
      },      
      getDiscount(item, nivel=1) {
        if(nivel==1) {
          return parseFloat(item.percentage_discount)
        }        
        if(nivel==2) {
          return parseFloat(item.percentage_discount_1)
        }        
        if(nivel==3) {
          return parseFloat(item.percentage_discount_2)
        }                        
      },
      getAdditional(item, nivel=1) {
        if(nivel==1) {
          return parseFloat(item.additional_percentage)
        }        
        if(nivel==2) {
          return parseFloat(item.additional_percentage_1)
        }                
      },
      diffLastUpdate(item) {
        if(item.last_update_price) {
          var dateNow = moment();
          var dateLast = moment(item.last_update_price);    
          return dateNow.diff(dateLast, 'days') + 1 
        } else {
          return 1000 
        }        
      },

      // HISTORICO PRECIOS
      showHistory(item) {              
        this.tableHistory.isBusy = true
        this.itemSelectedHistory = this.itemSelected + ' - (' + item.code + ') ' + item.name
        this.tableHistory.items = item.history.reverse()        

        this.modal.formHistory.title = "Historial de Precios"
        this.modal.formHistory.active = true
        this.tableHistory.isBusy = false
      },
      closeHistory() {
        this.modal.formHistory.active = false
      },     

      // CONFIGURACION PRODUCTOS
      loadListsPrices() {
        var result = serviceAPI.obtenerLista()        
        result.then((response) => {
          var data = response.data    
          data.forEach(element => {
            if(element.active) {
              this.arr.listPrices.push(element)
            }
          });
        })  
      },
      getUtility(item) {
        return item.utility / 100 
      },
      addProduct() {        
        this.itemSelectedConvert = this.itemSelected
        this.crud.formConvert.type = 'NUEVO'
        this.crud.formConvert.id = 0
        this.crud.formConvert.price_list = 0
        this.crud.formConvert.percentage_discount = 0
        this.crud.formConvert.percentage_discount_1 = 0
        this.crud.formConvert.percentage_discount_2 = 0
        this.crud.formConvert.additional_percentage = 0
        this.crud.formConvert.additional_percentage_1 = 0
        this.crud.formConvert.additional = 0        
        this.crud.formConvert.additional_1 = 0
        this.crud.formConvert.unit_measurement_purchase = null
        this.crud.formConvert.unit_measurement_purchase_id = 18
        this.crud.formConvert.suppliers_id = (this.filterQuery['suppliers_id'] != undefined) ? this.filterQuery['suppliers_id'] : 0
        
        this.crud.formConvert.products_id = 0
        this.crud.formConvert.products = null
        this.crud.formConvert.changeType = false        
        this.crud.formConvert.unit_measurement_sale = null
        this.crud.formConvert.unit_measurement_sale_id = 18
        this.crud.formConvert.unit_measurement_sale_conversion = 1

        this.crud.formConvert.barcode = ''
        this.crud.formConvert.code = ''
        this.crud.formConvert.name = ''
        this.crud.formConvert.category = (this.filterQuery['category'] != undefined) ? this.filterQuery['category'] : ''
        this.crud.formConvert.subcategory = (this.filterQuery['subcategory'] != undefined) ? this.filterQuery['subcategory'] : ''
        this.crud.formConvert.line = ''
        this.crud.formConvert.subline = ''
        this.crud.formConvert.depth = 0,
        this.crud.formConvert.long = 0,
        this.crud.formConvert.height = 0,
        this.crud.formConvert.weight = 0,
        this.crud.formConvert.iva_condition = null
        this.crud.formConvert.iva_condition_id = 5      

        this.arr.listPrices.forEach(element => {
          this.crud.formConvert.lists[element.id] = []
          this.crud.formConvert.lists[element.id]['price_list_id'] = element.id
          this.crud.formConvert.lists[element.id]['utility'] = 0
          this.crud.formConvert.lists[element.id]['desc'] = 0
        })
        
        this.modal.formConvert.title = "Nuevo Producto"
        this.modal.formConvert.active = true  
      },
      editProduct(item) {       
        this.itemSelectedConvert = this.itemSelected
        this.crud.formConvert.id = item.id

        this.crud.formConvert.type = 'EDITAR'
        this.crud.formConvert.price_list = item.price_list
        this.crud.formConvert.percentage_discount = item.percentage_discount 
        this.crud.formConvert.percentage_discount_1 = item.percentage_discount_1 
        this.crud.formConvert.percentage_discount_2 = item.percentage_discount_2 
        this.crud.formConvert.additional_percentage = item.additional_percentage
        this.crud.formConvert.additional_percentage_1 = item.additional_percentage_1
        this.crud.formConvert.additional = item.additional        
        this.crud.formConvert.additional_1 = item.additional_1        
        this.crud.formConvert.unit_measurement_purchase = item.unit_measurement_purchase
        this.crud.formConvert.unit_measurement_purchase_id = item.unit_measurement_purchase_id
        this.crud.formConvert.suppliers_id = item.suppliers_id
        
        this.crud.formConvert.products_id = item.products_id
        this.crud.formConvert.products = item.product
        this.crud.formConvert.changeType = false        
        this.crud.formConvert.unit_measurement_sale = item.product.unit_measurement_sale
        this.crud.formConvert.unit_measurement_sale_id = item.product.unit_measurement_sale_id
        this.crud.formConvert.unit_measurement_sale_conversion = item.product.unit_measurement_sale_conversion          

        this.crud.formConvert.barcode = item.barcode
        this.crud.formConvert.code = item.code
        this.crud.formConvert.name = item.name
        this.crud.formConvert.category = item.category
        this.crud.formConvert.subcategory = item.subcategory  
        this.crud.formConvert.line = item.line
        this.crud.formConvert.subline = item.subline
        this.crud.formConvert.depth = item.depth
        this.crud.formConvert.long = item.long
        this.crud.formConvert.height = item.height
        this.crud.formConvert.weight = item.weight
        this.crud.formConvert.iva_condition = null //no viene cargado, pero lo usa el combo
        this.crud.formConvert.iva_condition_id = item.iva_condition

        this.arr.listPrices.forEach(element => {
          this.crud.formConvert.lists[element.id] = []
          this.crud.formConvert.lists[element.id]['price_list_id'] = 0
          this.crud.formConvert.lists[element.id]['utility'] = 0
          this.crud.formConvert.lists[element.id]['desc'] = 0
        })

        this.arr.listPrices.forEach(element => {
          if(this.crud.formConvert.products_id) {
            var result1 = serviceAPI.mostrarProductosByLista({
              price_list_id: element.id,
              products_id: this.crud.formConvert.products_id,
            })        
            result1.then((response1) => {
              var data1 = response1.data
              this.crud.formConvert.lists[element.id]['price_list_id'] = parseFloat(data1.products.price_list_id)
              this.crud.formConvert.lists[element.id]['utility'] = parseFloat(data1.products.utility)
              this.crud.formConvert.lists[element.id]['desc'] = parseFloat(data1.products.desc)
              this.convertPriceForceUpdate()
            })                                                
          }
        });

        this.modal.formConvert.title = "Editar Producto"
        this.modal.formConvert.active = true        
      },
      changeTypeConvert() {
        if(this.crud.formConvert.type == 'NUEVO') {
          this.crud.formConvert.products_id = 0
          this.crud.formConvert.products = null
        }
        if(this.crud.formConvert.type == 'EDITAR') {
          this.crud.formConvert.code = ''
        }        
      },
      loadProductsConvert(object) {
        if(object){
          this.crud.formConvert.products = object
          this.crud.formConvert.products_id = object.id
        } else {
          this.crud.formConvert.products = null
          this.crud.formConvert.products_id = 0
        }
      },
      loadUnitMeasurementPurchase(object) {
        if(object){
          this.crud.formConvert.unit_measurement_purchase = object
          this.crud.formConvert.unit_measurement_purchase_id = object.id  
        } else {
          this.crud.formConvert.unit_measurement_purchase = null
          this.crud.formConvert.unit_measurement_purchase_id = 0
        }
      },
      loadUnitMeasurementSale(object) {
        if(object){
          this.crud.formConvert.unit_measurement_sale = object
          this.crud.formConvert.unit_measurement_sale_id = object.id
        } else {
          this.crud.formConvert.unit_measurement_sale = null
          this.crud.formConvert.unit_measurement_sale_id = 0
        }
      }, 
      loadIvaConditions (object) {
        if(object){
          this.crud.formConvert.iva_condition = object
          this.crud.formConvert.iva_condition_id = object.id             
        } else {
          this.crud.formConvert.iva_condition = null
          this.crud.formConvert.iva_condition_id = 0
        }
      },                 
      saveProduct() {  
        var modalTitle = ''      
        var modalContent = ''

        if(this.crud.formConvert.type=='EDITAR') {
          if(!this.crud.formConvert.products_id) {
            this.$awn.alert("No se cargó la relación con el producto");
            return false
          }

          modalTitle = '¿Continuar con la edición del producto?'
          modalContent = 'Editar Producto'
        }

        if(this.crud.formConvert.type=='NUEVO') {
          if(!this.crud.formConvert.code) {            
            this.$awn.alert("No se cargo el código");
            return false            
          }

          modalTitle = '¿Agregar el nuevo producto?'
          modalContent = 'Agregar Producto'          
        }        
        
        this.$bvModal.msgBoxConfirm(modalContent, {
          title: modalTitle,
          size: 'md',
          buttonSize: 'md',
          okVariant: 'dark',
          okTitle: 'GUARDAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {          
          if (value) {            
            let loader = this.$loading.show();
            
            // preparar datos
            var lists = this.crud.formConvert.lists
            this.crud.formConvert.lists = []
            
            lists.forEach(element => {
              this.crud.formConvert.lists.push({price_list_id: element.price_list_id, utility: element.utility, desc: element.desc})
            });
            // fin preparar datos
            
            var result = serviceAPI.saveProduct(this.crud.formConvert);

            result.then((response) => {              
              this.modal.formConvert.active = false              
              loader.hide()
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)
              this.$awn.success("Registro configurado con éxito");
            })
            .catch(error => {                     
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {    
          this.$awn.alert(Error.showError(error));
        })            
      },
      convertPriceForceUpdate() {
        this.convertPriceForceUpdateKey = this.convertPriceForceUpdateKey + 1
      },
      loadSuppliersAddProduct(object) {
        if(object){
          this.crud.formConvert.suppliers = object
          this.crud.formConvert.suppliers_id = object.id
        } else {
          this.crud.formImport.suppliers = null
          this.crud.formImport.suppliers_id = 0
        }
      },      

      // MARCAR POR DEFAULT
      setDefault(item) {        
        this.$bvModal.msgBoxConfirm('¿Marcar producto de proveedor por Default para obtener el precio de venta?', {
          title: 'Marcar Por Default',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'dark',
          okTitle: 'MARCAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {          
          if (value) {            
            let loader = this.$loading.show();
            
            var result = serviceAPI.marcarDefault({
              id: item.id
            });

            result.then((response) => {                            
              loader.hide()
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)
              this.$awn.success("Registro marcado con éxito");
            })
            .catch(error => {                     
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {    
          this.$awn.alert(Error.showError(error));
        })    
      },

      // COMPARAR PRECIOS
      showCompare(item) {              
        this.tableCompare.isBusy = true
        this.itemSelectedCompare = '(' + item.product.code + ') ' + item.product.name
                
        var result = serviceAPI.compareProductos({
          products_id: item.products_id,
        })        
        result.then((response) => {
          var data = response.data
          this.tableCompare.items = data        
        })                  

        this.modal.formCompare.title = "Comparar precios con otros proveedores"
        this.modal.formCompare.active = true
        this.tableCompare.isBusy = false
      },
      closeCompare() {
        this.modal.formCompare.active = false
      },
      formatNumber(valor) {
        return valor.toLocaleString()
      },

      // CAMBIO DE PRECIOS
      initChangePrice() {
        this.statusEditPrice = true;
        this.$awn.warning("Iniciando edición de precios");        
      },
      endChangePrice() {
        this.statusEditPrice = false;
        this.$awn.warning("Finalizando edición de precios");
      },     
      savePrice(item) {
        this.$bvModal.msgBoxConfirm('¿Actualizar precio de lista?', {
          title: 'Actualizar Precio',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'ACTUALIZAR',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            var result = serviceAPI.updateProducto({
              id: item.id,
              product_id: item.product_id,
              price_list: item.price_list,
            })
                          
            result.then((response) => {                                                                                       
              this.$awn.warning("Actualizando precio de lista");

              //this.filterLoad()
              //this.loadSuppliers()
              this.selectedItem(this.filterQuery, true, false, 'Precio de lista actualizado')              
            })
            .catch(error => {                              
              //this.filterLoad()
              //this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)                         
              this.$awn.alert(Error.showError(error));
            })  
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })  
      },
      
      // ELIMINAR PRODUCTO
      deleteProduct(item) {
        this.$bvModal.msgBoxConfirm('¿Eliminar el producto ['+item.code + '] - ' + item.name + '?', {
          title: 'Eliminar producto',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'ELIMINAR',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            var result = serviceAPI.deleteProducto({
              id: item.id,              
            })
                          
            result.then((response) => {                                  
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)              

              this.$awn.success("Producto eliminado");
            })
            .catch(error => {                              
              this.filterLoad()
              this.loadSuppliers()
              this.selectedItem(this.filterQuery, true)                         
              this.$awn.alert(Error.showError(error));
            })  
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })  
      },

      // EDITAR LOTE
      showEditPriceLote() {
        this.modal.formEditPriceLote.title = "Edición de precios por lotes"
        this.modal.formEditPriceLote.active = true

        this.crud.formEditPriceLote.percentage = 0
        this.crud.formEditPriceLote.operations = '+'
        this.crud.formEditPriceLote.filterQuery = []        
      },
      closeEditPriceLote() {
        this.modal.formEditPriceLote.active = false
      },      
      saveEditPriceLote() {                       
        if(parseFloat(this.crud.formEditPriceLote.percentage) <= 0) {
          this.$awn.alert("El porcentaje debe ser mayor a cero");
          return false
        }
        
        this.$bvModal.msgBoxConfirm('¿Actualizar todos los precio un ' + this.crud.formEditPriceLote.percentage + '%?', {
          title: 'Actualización Precios',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'ACTUALIZAR',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {          
          if (value) {  
            let loader = this.$loading.show();        
                    
            this.crud.formEditPriceLote.filterQuery = this.filterQuery
            this.crud.formEditPriceLote.filterQuery.paginate = false

            var result = serviceAPI.updateProductoLote(this.crud.formEditPriceLote)
                          
            result.then((response) => {                                                                                                                
              this.modal.formEditPriceLote.active = false   

              this.crud.formEditPriceLote.percentage = 0
              this.crud.formEditPriceLote.operations = '+'
              this.crud.formEditPriceLote.filterQuery = []

              loader.hide()

              this.selectedItem(this.filterQuery, true, true, 'Precios actualizados '+ this.crud.formEditPriceLote.percentage + '%')                                                          
            })
            .catch(error => {                              
              this.modal.formEditPriceLote.active = false 
              
              this.crud.formEditPriceLote.percentage = 0
              this.crud.formEditPriceLote.operations = '+'
              this.crud.formEditPriceLote.filterQuery = []

              loader.hide()

              this.selectedItem(this.filterQuery, true)
              this.$awn.alert(Error.showError(error));
            })              
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));          
        })  
      },

      // DESCUENTO LOTE
      showEditDiscountLote() {
        this.modal.formEditDiscountLote.title = "Configuración de descuentos"
        this.modal.formEditDiscountLote.active = true

        this.crud.formEditDiscountLote.discount1 = 0              
        this.crud.formEditDiscountLote.discount2 = 0              
        this.crud.formEditDiscountLote.discount3 = 0              
        this.crud.formEditDiscountLote.filterQuery = []        
      },
      closeEditDiscountLote() {
        this.modal.formEditDiscountLote.active = false        
      },      
      saveEditDiscountLote() {        
        if(parseFloat(this.crud.formEditDiscountLote.discount1) <= 0 && parseFloat(this.crud.formEditDiscountLote.discount2) <= 0 && parseFloat(this.crud.formEditDiscountLote.discount3) <= 0) {
          this.$awn.alert("Debe completar algún descuento para realizar esta operación");
          return false
        }
        
        this.$bvModal.msgBoxConfirm('¿Continuar con la actualización de descuentos para los productos filtrados?', {
          title: 'Actualización Descuentos',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'ACTUALIZAR',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {          
          if (value) {  
            let loader = this.$loading.show();        
                    
            this.crud.formEditDiscountLote.filterQuery = this.filterQuery
            this.crud.formEditDiscountLote.filterQuery.paginate = false

            var result = serviceAPI.updateProductoDescuentoLote(this.crud.formEditDiscountLote)
                          
            result.then((response) => {                                                                                                                
              this.modal.formEditDiscountLote.active = false   

              this.crud.formEditDiscountLote.discount1 = 0              
              this.crud.formEditDiscountLote.discount2 = 0              
              this.crud.formEditDiscountLote.discount3 = 0              
              this.crud.formEditDiscountLote.filterQuery = []

              loader.hide()

              this.selectedItem(this.filterQuery, true, true, 'Descuentos actualizados')                                                          
            })
            .catch(error => {                              
              this.modal.formEditDiscountLote.active = false 
              
              this.crud.formEditDiscountLote.discount1 = 0              
              this.crud.formEditDiscountLote.discount2 = 0              
              this.crud.formEditDiscountLote.discount3 = 0              
              this.crud.formEditDiscountLote.filterQuery = []

              loader.hide()

              this.selectedItem(this.filterQuery, true)
              this.$awn.alert(Error.showError(error));
            })              
          }
        })    
        .catch(error => {
          this.$awn.alert(Error.showError(error));          
        })          
      }      
    }       
  }
</script>
<style>
  .crud-price-list-suppliers-table-action button {
    padding: 0px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .crud-price-list-suppliers-table-action i {
    color: #23282c;
  }
  .crud-price-list-suppliers-download {
    float: left;
    margin-right: 10px;    
  }  
  #cost-tree-suppliers .vtl-tree-margin {
    margin-left: 10px;
  }
  #cost-tree-suppliers .vtl-node-main {
    padding: 0px 0 0px 10px;
  }
  #cost-tree-suppliers .vtl-node-content {
    font-size: 10px;
  }
  .cost-supplier-products-history-overflow {
    overflow: auto;    
    max-height: 400px;
  }
  .cost-supplier-products-edit-overflow {
    overflow: auto;
    max-height: 450px;    
  }
</style>
<style scoped>
  .input-group-sm .input-group-prepend .input-group-text {
    padding: 3px;
  }
  .input-group-sm .input-group-append .btn {
    padding: 1px;
  }  
  .input-group-sm .form-control {
    padding: 2px;
  }    
  .dropdown-divider {    
    margin: 3px;
  }
</style>